<template>
  <div class="statementsList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @settleChange="settleChange"
      @productChange="productChange"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :width="item.width"
          :min-width="120"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'statementsList',
    mixins: [tableMixins],
    data() {
      return {
        exportAction: API.EXPORT_ORDERSETTLESLIP,
        query: {
          slipCompanyNo: null, // 公司代码
          slipDepartmentNo: null, // 事业部门
          slipDate: null, // 结算日期
          settleNo: null, // 结算批次编号
          settleDesc: null, // 结算批次描述
          supplierNo: null, // 供应链主体
          orderNo: null, // 业务订单
          settleType: null, // 结算类型
          productNo: null, // 商品编码
          productDesc: null, // 商品描述
          slipStatus: null, // 结算单状态
        },
        companyList: [],
        departmentList: [],
        columnListDefault: [
          { type: 'checkbox', width: 50, fixed: 'left' },
          { field: 'slipCompanyName', title: 'statementsList.table.slipCompanyName' }, // 公司
          { field: 'slipDepartmentName', title: 'statementsList.table.slipDepartmentName' }, // 事业部门
          { field: 'slipNo', title: 'statementsList.table.slipNo' }, // 结算单号
          { field: 'slipDesc', title: 'statementsList.table.slipDesc' }, // 结算单描述
          {
            field: 'slipStatus',
            title: 'statementsList.table.slipStatus',
            width: 100,
            dictType: 'slip_status',
          }, // 结算单状态
          // 供应链服务协议号
          { field: 'settleNo', title: 'batchList.column.settleNo' }, // 结算批次编号
          { field: 'settleDesc', title: 'batchList.column.settleDesc' }, // 结算批次描述
          { field: 'supplierName', title: 'batchList.column.supplierNo' }, // 供应链主体
          { field: 'productNo', title: 'statementsList.table.productNo' }, // 商品编码
          { field: 'productDesc', title: 'statementsList.table.productDesc' }, // 商品描述
          { field: 'settleQuantity', title: 'statementsList.table.settleQuantity' }, // 结算数量
          { field: 'slipDate', title: 'statementsList.table.slipDate' }, // 结算日期
          { field: 'slipCreatePersonName', title: 'statementsList.table.slipCreatePersonName' }, // 创建人
          { field: 'mark', title: 'statementsList.table.mark' }, // 备注
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            // 公司代码
            prop: 'slipCompanyNo',
            name: this.$t('statementsList.search.slipCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 事业部门
            prop: 'slipDepartmentNo',
            name: this.$t('statementsList.search.slipDepartmentNo'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 结算日期
            prop: 'slipDate',
            name: this.$t('statementsList.search.slipDate'),
            type: 'endDaterangePicker',
          },
          {
            // 结算批次编号
            prop: 'settleNo',
            name: this.$t('statementsList.search.settleNo'),
            type: 'searchTableSpec',
            searchType: 'settle',
            isMultiple: true,
            currentValue: this.query.settleNo,
            changeMethod: 'settleChange',
          },
          {
            // 结算批次描述
            prop: 'settleDesc',
            name: this.$t('statementsList.search.settleDesc'),
            type: 'searchTableSpec',
            searchType: 'settle',
            isMultiple: true,
            currentValue: this.query.settleDesc,
            changeMethod: 'settleChange',
          },
          {
            // 供应链主体
            prop: 'supplierNo',
            name: this.$t('statementsList.search.supplierNo'),
            type: 'searchTableSpec',
            searchType: 'supplychain',
            isMultiple: true,
          },
          {
            // 业务订单
            prop: 'orderNo',
            name: this.$t('statementsList.search.orderNo'),
            type: 'searchTableSpec',
            searchType: 'businessOrder',
            isMultiple: true,
          },
          {
            // 结算类型
            prop: 'settleType',
            type: 'dict',
            name: this.$t('statementsList.search.settleType'),
            dictType: 'settle_type',
          },
          {
            // 商品编码
            prop: 'productNo',
            name: this.$t('statementsList.search.productNo'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productNo,
            changeMethod: 'productChange',
          },
          {
            // 商品描述
            prop: 'productDesc',
            name: this.$t('statementsList.search.productDesc'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productDesc,
            changeMethod: 'productChange',
          },
          {
            // 结算单状态
            prop: 'slipStatus',
            type: 'dict',
            name: this.$t('statementsList.search.slipStatus'),
            dictType: 'slip_status',
          },
        ];
      },
    },
    mounted() {
      this.getCompany();
      this.getData();
      this.getButtonList();
    },
    methods: {
      getData() {
        // 获取数据
        const params = this.setSearchParams();
        this.load = true;
        this.$axios.post(API.LIST_ORDER_SETTLE_SLIP_BY_PAGE, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        params.supplierNo = params.supplierNo ? params.supplierNo[0].supplierCode : null;
        params.orderNo = params.orderNo ? params.orderNo[0].orderNo : null;
        return params;
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.slipDepartmentNo = null;
        this.getDepartment(val.val);
      },
      settleChange(val) {
        this.searchTableChange(val.val, [{ val: 'settleNo' }, { val: 'settleDesc' }]);
      },
      productChange(val) {
        this.searchTableChange(val.val, [
          { val: 'productNo', getVal: 'productDetailCode' },
          { val: 'productDesc', getVal: 'detailProductDisplayName' },
        ]);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.query[item.val] = val[0][item.getVal];
            } else {
              this.query[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.query[item.val] = null;
          });
        }
      },
      chooseClick(type) {
        if (type == 'add') {
          this.toPath('statementsAdd', {});
        } else if (type == 'edit') {
          if (this.multipleSelection.length != 1) {
            return this.tips('onlyOneSelectData', 'error');
          }
          this.toPath('statementsEdit', { id: this.multipleSelection[0].id });
        } else if (type == 'del') {
          this.handleDel();
        } else if (type == 'export') {
          this.handleImport();
        }
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('statementsDetail', { id: value.row.id });
      },
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      handleDel() {
        // 删除
        if (this.multipleSelection.length == 0) return this.tips('noSelected', 'error');
        let ids = this.multipleSelection.map((i) => i.id);
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.BATCH_DELETE_ORDER_SETTLE_SLIP, ids).then((res) => {
              if (res.data.code == 0) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`batchList.message.${info}`),
          type: type,
        });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/settle/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
